export default __webpack_public_path__ + "a9c68ca00ad7ffffc5361232c9c3115a.png";